<template>
    <div class=".container.is-max-widescreen">
         <navbar/>
        <section class="hero">
            <div class="hero-body">
            <div class="container">
                <h1 class="title is-4">
                  Votre lien est expiré, veuillez resaisir votre email pour recevoir votre lien ...
                </h1>
                    <s-input 
                        v-model="email" 
                        placeholder="Votre email" 
                        theme="is-success" 
                        mandatory="true"/>
                    <div class="error" v-show="email==''">
                        L'email est obligatoire
                    </div>
                <div>
                    <br/>
                    <s-button icon="" theme="is-success" label="S'incrire" @onclick="login"
                    :disabled="email==''"/>
                </div>
                 <s-modal 
                            title="Confirmation"
                            :open="confirmation"
                        >
                            Un mail vient de vous être adressé.<br/>
                            Veuillez consulter votre messagerie et cliquez sur le lien pour vous connecter</br>
                            <br/>
                            <s-button theme="is-success is-large" label="J'ai compris" @onclick="home()"/>
                        </s-modal>
            </div>
        </div>
    </section>
    </div>
</template>
<style  scoped>
    .error {
        font-size: 12px;
        font-style: italic;
        color: rgb(206, 50, 50);
    }
</style>
<script>
import firebase from "firebase/app"
export default {
    data() {
        return {
            email: "",
            confirmation: false
        }
    },
    methods: {
        home() {
            this.$router.push({name: "home"});
        },
        login() {
            var originUrl = window.location.origin;
            var actionCodeSettings = {
                    // URL you want to redirect back to. The domain (www.example.com) for this
                    // URL must be whitelisted in the Firebase Console.
                url: originUrl + '/LoginByEmail', 
                    // This must be true.
                    handleCodeInApp: true
                };

            firebase.auth().sendSignInLinkToEmail(this.email, actionCodeSettings)
                .then(()=> {
                    // The link was successfully sent. Inform the user.
                    // Save the email locally so you don't need to ask the user for it again
                    // if they open the link on the same device.
                   
                    window.localStorage.setItem('emailForSignIn', this.email);
                    this.confirmation = true;
                     
                })
                .catch(function(error) {
                    // Some error occurred, you can inspect the code: error.code
                    console.log(error);
                });
        }
    }
}
</script>